// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { Component } from "react";
import { connect } from "react-redux";

import PropTypes from "prop-types";
import { getSelectedDeviceModels } from "reduxReusable/selectedTargets/selectors";

import { Accordion } from "components/layout";
import { trans } from "src/translations";

import { SELECTED_TARGETS_STORE_PATH } from "../redux/constants";

const makeMapStateToProps = () => {
  return (state) => {
    return {
      selectedModels: getSelectedDeviceModels(state, {
        storePath: SELECTED_TARGETS_STORE_PATH,
      }),
    };
  };
};

@connect(makeMapStateToProps)
export class SelectedModels extends Component {
  static propTypes = {
    className: PropTypes.string,
    selectedModels: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        familyId: PropTypes.number.isRequired,
        distributorId: PropTypes.string.isRequired,
      })
    ).isRequired,
  };

  render() {
    const { selectedModels, className } = this.props;

    return (
      <Accordion
        className={className}
        header={trans.APP_DETAILS_MODERATION_TARGETS__AFFECTED_DEVICES()}
        headerType="compact"
        preview={4}
      >
        <ul>
          {selectedModels.map((m) => (
            <li key={m.id}>{m.name}</li>
          ))}
        </ul>
      </Accordion>
    );
  }
}
